import React, { useState, useEffect, useContext } from 'react'
import axios from 'axios'
import { UserContext } from '../../UserContext';
import { CopyToClipboard } from 'react-copy-to-clipboard';

// Don't think this is being used anymore...

const RepDash = () => {

  const [customers, setCustomers] = useState([])
  const [proposals, setProposals] = useState([])
  const [projectId, setProjectId] = useState('')
  const [custName, setCustName] = useState('')
  const [copied, setCopied] = useState(false)
  const [viewProps, setViewProps] = useState(false)
  const [showError, setShowError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const { activeUser, setActiveUser } = useContext(UserContext);

  const getCustomers = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'get_sales_id', Email: activeUser.username, LastName: activeUser.attributes.family_name }).then(
      (res) => {
        console.log(res.data)
        return setCustomers(res.data.customers)
      }
    )
  }

  useEffect(() => {
    getCustomers()
  }, [])

  const copier = (size, type) => {
    return setShowError(true),
      setErrorMessage(`${size / 1000} kW ${type} copied to clipboard`),
      setTimeout(function () {
        setShowError(false)
        setErrorMessage(``)
      }, 10000)
  }

  const mappedProposals = proposals.map((proposal, i) => {

    let custLink;
    if (custName) {
      custLink = Math.round(Math.random() * (9999 - 1000) + 1000) + `${custName.split(" ").join("")}`
    }

    const linkOut = () => {
      return window.open(`https://proposalist.iondeveloper.com/?proj_id=${projectId}#/propview/${proposal.propId}/${i + 1}/1`, '_blank')
    }

    const linkOutCust = () => {
      return window.open(`https://proposalist.iondeveloper.com/?proj_id=${projectId}#/customerpropview/${proposal.propId}/${i + 1}/${custLink}`, '_blank')
    }



    return (
      <tr className='container' key={i}>
        <td className='qualyText bold' >{(+proposal.totalSystemCost).toLocaleString(undefined, { style: "currency", currency: "USD" })}</td>
        <td className='qualyText bold' >{proposal.propSize / 1000} kW</td>
        <td className='qualyText bold' >{proposal.offset}%</td>
        <td className='qualyText bold' >
          <span onClick={() => linkOutCust()} className='qualyText bold'>View </span>
          <CopyToClipboard onCopy={() => { setCopied(true); copier(proposal.propSize, 'Customer') }} text={`https://proposalist.iondeveloper.com/?proj_id=${projectId}#/customerpropview/${proposal.propId}/${i + 1}/${custLink}`}>
            <span className='qualyText bold'> Copy</span>
          </CopyToClipboard>
        </td>
        <td className='qualyText bold' >
          <span onClick={() => linkOut()} className='qualyText bold'>View </span>
        </td>
      </tr>
    )
  })

  const mappedCustomers = customers.map((customer, i) => {
    const getCustProposals = (id) => {
      axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'get_cust_proposals', project_id: id }).then(
        (res) => {
          console.log(res.data)
          return setProjectId(id),
            setProposals(res.data.data)
        }
      )
    }

    return (
      <tr className='container' key={i}>
        <td className='qualyText bold' >{customer.name}</td>
        <td className='qualyText bold' onClick={() => { getCustProposals(customer.id); setViewProps(!viewProps); setCustName(customer.name) }} >View</td>
      </tr>
    )
  })

  return (
    <>
      <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet"
        integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossOrigin="anonymous"></link>
      {viewProps ? (
        <div className='container'>
          <div className='row'>
            <div className='col'>
              <h1 className='qualyText header'>{custName}</h1>
            </div>
            <div className='col' align="Right">
              <h1 className='qualyText header' onClick={() => setViewProps(!viewProps)}>Back</h1>
            </div>
          </div>
          {proposals.length < 1 ? (
            <>
              <h2 className='qualyText header'>No Proposals to show</h2>
            </>
          ) : (
            <>
              <table className='table table-striped table-borderless'>
                <thead>
                  <tr className='table-borderless'>
                    <th className='qualyText' scope="col">System Cost</th>
                    <th className='qualyText' scope="col">System Size</th>
                    <th className='qualyText' scope="col">Offset</th>
                    <th className='qualyText' scope="col">Customer Link</th>
                    <th className='qualyText' scope="col">Rep Link</th>
                  </tr>
                </thead>
                <tbody>
                  {mappedProposals}
                </tbody>
              </table>
            </>
          )}
          {showError ? <div className='errorMessage green'>{errorMessage}</div> : null}
        </div>
      ) : (
        <>
          <div className='container'>
            <div className='row'>
              <div className='col'>
                <h1 className='qualyText header'>{activeUser.attributes.given_name} {activeUser.attributes.family_name}'s Customers</h1>
              </div>
            </div>
            {customers.length < 1 ? (
              <>
                <h2 className='qualyText header'>No Customers to show</h2>
              </>
            ) : (
              <>
                <table className='table table-striped table-borderless'>
                  <thead>
                    <tr className='table-borderless'>
                      <th className='qualyText' scope="col">Customer Name</th>
                      <th className='qualyText' scope="col">Proposals</th>
                    </tr>
                  </thead>
                  <tbody>
                    {mappedCustomers}
                  </tbody>
                </table>
              </>
            )}
          </div>
        </>
      )
      }
    </>
  )
}

export default RepDash